import React from 'react'

export default function () {
	return (
		<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
			<path d="M11.0750625,23.5157812 C4.26421875,13.6420781 3,12.6287344 3,9 C3,4.02942187 7.02942187,0 12,0 C16.9705781,0 21,4.02942187 21,9 C21,12.6287344 19.7357812,13.6420781 12.9249375,23.5157812 C12.4779844,24.1614375 11.5219687,24.1613906 11.0750625,23.5157812 Z M12,12.75 C14.0710781,12.75 15.75,11.0710781 15.75,9 C15.75,6.92892188 14.0710781,5.25 12,5.25 C9.92892188,5.25 8.25,6.92892188 8.25,9 C8.25,11.0710781 9.92892188,12.75 12,12.75 Z"></path>
		</svg>
	)
}
